import { AuthUtils } from "app/core/auth/auth.utils";

export interface PermissionClaims {
  userId: string | null;
  isAdmin: boolean;
  isStaff: boolean;
}

const EMPTY: PermissionClaims = { userId: null, isAdmin: false, isStaff: false };

/** Lê do JWT as informações que o backend usa em `hasFullAccess`. */
export function parseClaims(token: string | null | undefined): PermissionClaims {
  if (!token) {
    return { ...EMPTY };
  }

  try {
    const payload = AuthUtils.decodeToken(token);

    if (!payload) {
      return { ...EMPTY };
    }

    return {
      userId: typeof payload.userId === "string" ? payload.userId : null,
      isAdmin: payload.isAdmin === true,
      isStaff: payload.isStaff === true,
    };
  } catch {
    return { ...EMPTY };
  }
}
